export default __webpack_public_path__ + "static/media/r6.37ce6c4d.jpg";